var exports = {
  "w": "x93eb46d8--4edfae--postfix",
};

module.exports = exports;
